import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";



// Async thunk for fetching wallet transactions
export const fetchWalletTransaction = createAsyncThunk(
    "walletTransaction/fetch",
    async ({ endDate, startDate }, { rejectWithValue }) => {
        try {
            // Call the API to fetch wallet transactions
            const response = await request({
                endpoint: "/user/wallet/walletTransaction", // Replace with your actual endpoint
                method: "GET",
                params: { startDate, endDate }
            });

            console.log("Fetch Wallet Transactions Response:", response);

            // Check if the fetch operation was successful
            if (!response.data || !Array.isArray(response.data)) {
                return rejectWithValue(response.message || "Failed to fetch wallet transactions.");
            }

            // Return the fetched wallet transactions
            return response.data; // Assuming the response contains an array of transactions in `transactions`
        } catch ({ error }) {
            console.error("Error fetching wallet transactions:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching wallet transactions.");
        }
    }
);

const initialState = {
    walletTransactions: [], // Array to store all wallet transactions
    loading: false,
    error: null,
};

const walletTransactionSlice = createSlice({
    name: "walletTransaction",
    initialState,
    reducers: {
        addWalletTransactions: (state, action) => {
            state.walletTransactions = action.payload;
        },
        clearWalletTransactions: (state) => {
            state.walletTransactions = [];
            state.loading = false;
            state.error = null;
        },
        addWalletTransaction: (state, action) => {
            state.walletTransactions.push(action.payload);
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Wallet Transactions
            .addCase(fetchWalletTransaction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWalletTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.walletTransactions = action.payload; // Update the wallet transactions array
            })
            .addCase(fetchWalletTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store the error message
            });
    },
});

export const { clearWalletTransactions, addWalletTransactions, addWalletTransaction } = walletTransactionSlice.actions;
export default walletTransactionSlice.reducer;